import { FunctionComponent } from 'react';
import IntroMainContentDefault from './variants/IntroMainContentDefault';
import { IntroMainContentVariants } from './IntroMainContent.types';

export const INTRO_MAIN_CONTENT_COMPONENTS: Record<
  IntroMainContentVariants,
  FunctionComponent<object>
> = {
  default: IntroMainContentDefault,
};
